import {Component,OnInit,Input, SimpleChanges, OnChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import Exporting from "highcharts/modules/exporting";
Exporting(Highcharts);

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit, OnChanges {

   @Input() chartData: object;
   @Input() chartId;
   barChart = Highcharts;
   chartOptions = {};
   context;
   @Input() yAxisPlot = [];
   chart: any;

   constructor() {}

   ngOnInit() {
      this.createBarChart();
   }

   ngOnChanges(changes: SimpleChanges): void {
      this.createBarChart();
   }

   createBarChart(): any {
      //  this.context = document.getElementById(this.chartId);
      this.chartOptions = {
         exporting : {
            enabled: true
         },
         chart: {
            type: 'column'
            // height : 500
         },
         title: {
            text: this.chartData['title'],
            align: 'left'
         },
         colors: ['#7ec0e0'],
         xAxis:{
            categories: this.yAxisPlot, 
            title: {
            text: null
            } 
         },
         yAxis : {
            // min: 0, 
            title: {
               text: null
            },
            labels: {
               overflow: 'justify'
            }
            
         },
         tooltip: {
            //  pointFormat: '{series.name}: <b>{point.y}</b>'
            // valueSuffix: ' hundreds'
            valueDecimals: 2
         },
         plotOptions : {
            bar: {
               dataLabels: {
                  enabled: true,
                  crop: false,
                  overflow: "none",
                  allowOverlap : true
                  // filter: {
                  //    property: 'y',
                  //    operator: '>',
                  //    value: 25
                  //  },
               }
            },
            series: {
               pointWidth: 20
            }
         },
         credits:{
            enabled: false
         },
         series: this.chartData['seriesdata']
      };
      console.log(this.chartId);
      setTimeout(() => {

         if(this.chart){
            this.chart.destroy();
         }
         this.chart = this.barChart.chart(this.chartId, this.chartOptions)        
      }, 0)
   }
}
